import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
	switchMainTabDispatch, unsetCommitteeTab, switchPage,
	committeeDirectLinkSwitchTab, policyGroupFilter
} from '../actions';
import FilterPolicyGroups from './filter-policy-groups';
import CommitteeBox from './committee-box';
import Pagination from './pagination';

class CommitteesPage extends Component {

	constructor( props ) {
		super( props );
		let current_tab = 'All';
		// if ( this.props.myCommittees.length >= 1 ) {
		// 	current_tab = 'My Committees';
		// }
		this.props.switchPage( 'committees', 1 );
		this.committeesPerPage = 8;
		this.directLinkCommitteeCode = getDirectCcode();
		this.state = {
			current_tab   : current_tab,
			show_filter   : false,
			current_page  : 1,
			filter_keyword: '',
			committeesNotIn: false
		};
	}

	filterCommittees( committees ) {
		let filtered_committees = committees;
		if ( this.props.selectedPolicyGroup !== '' ) {
			filtered_committees = committees.filter( committee => committee.policyGroup.toLowerCase() === this.props.selectedPolicyGroup.toLowerCase() );
		}
		if ( this.state.filter_keyword !== '' ) {
			const search = this.state.filter_keyword.toLowerCase();
			filtered_committees = filtered_committees.filter( committee => committee.title.toLowerCase()
			                                                                        .includes( search ) || committee.code.toLowerCase() === search || committee.description.toLowerCase()
			                                                                                                                                                   .includes( search ) || committee.policyGroup.toLowerCase()
			                                                                                                                                                                                   .includes( search ) || committee.contact.toLowerCase()
			                                                                                                                                                                                                                   .includes( search ) );
		}
		return filtered_committees;
	}

	getCommittees() {

		switch ( this.state.current_tab ) {
			// case 'My Committees':
			// 	return this.filterCommittees( this.myCommitteesWithAttr )
			// 	           .map( committee =>
			// 		                 <CommitteeBox is_part_of_committee={ true } committee={ committee } /> );
			// 	break;
			case 'All':
				return this.filterCommittees( this.shownCommittees )
				           .map( committee =>
					                 <CommitteeBox committee={ committee } /> );
				break;
			case 'Working Groups':
				return this.filterCommittees( this.workingGroups )
				           .map( committee =>
					                 <CommitteeBox committee={ committee } /> );
				break;
			case 'Distribution Lists':
				return this.filterCommittees( this.distributionList )
				           .map( committee =>
					                 <CommitteeBox committee={ committee } /> );
				break;
		}
	}

	getTabs() {
		let tabs = [ 'All', 'Working Groups', 'Distribution Lists' ];
		// if ( this.props.myCommittees.length >= 1 ) {
		// 	tabs.unshift( 'My Committees' );
		// }
		let htmlTabs = tabs.map( tab => {
			let activeTab = (this.state.current_tab === tab
			                ) ? 'active' : '';	
			return (
				<li name={tab} role="tab" className={ activeTab } onClick={ this.switchTab.bind( this, tab ) } type="button">{ tab } ({ this.getCommitteesTabCount( tab ) })</li>
			);
		} );
		return (<ul className="nav nav-tabs">
			{ htmlTabs }
		</ul>);
	}

	switchTab( tabName ) {
		let newState = this.state;
		newState.current_tab = tabName;
		this.props.switchPage( 'committees', 1 );
		this.setState( newState );

	}

	getCommitteesTabCount( tab = '' ) {
		const allCommittees = this.distributionList.concat( this.workingGroups ).filter( committee => this.props.myCommittees.includes( committee.code ) || committee.isPublic === '1' );
		
		let tabSelected = (tab === ''
		                  ) ? this.state.current_tab : tab;
		switch ( tabSelected ) {
			// case 'My Committees':
			// 	return this.myCommitteesWithAttr.length;
			// 	break;
			case 'All':
				return allCommittees.length;
				break;
			case 'Distribution Lists':
				return this.distributionList.length;
				break;
			case 'Working Groups':
				return this.workingGroups.length;
				break;

		}
	}

	handleSearch( event ) {
		this.setFilterKeywordByValue( event.target.value );
	}

	setFilterKeywordByValue( value ) {
		this.props.switchPage( 'committees', 1 );
		let newState = this.state;
		newState.filter_keyword = value;
		this.setState( newState );
	}

	clearFilters() {
		this.setFilterKeywordByValue( '' );
		this.props.policyGroupFilter( '' );
	}

	handleCommitteesNotInClick() {
		let newState = this.state;
		newState.committeesNotIn = !newState.committeesNotIn;
		this.setState( newState );
	}

	getFilterOptions() {
		return (
		<div className="filter-container">
			    <div className="filter-container__left-content">
				<FilterPolicyGroups />
				<div className="filter-input-container">
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M13.3243 10.5833V8.33335C13.3243 8.11233 13.4121 7.90037 13.5684 7.74409C13.7247 7.58781 13.9366 7.50001 14.1576 7.50001H14.991C15.212 7.50001 15.424 7.41222 15.5802 7.25594C15.7365 7.09966 15.8243 6.88769 15.8243 6.66668V5.83335C15.8243 5.61233 15.9121 5.40037 16.0684 5.24409C16.2247 5.08781 16.4366 5.00001 16.6576 5.00001H18.8951C19.0577 4.99922 19.2166 4.95166 19.3528 4.86299C19.4891 4.77433 19.5969 4.64832 19.6635 4.50001C19.9449 3.88016 20.0532 3.19564 19.9768 2.51918C19.8816 1.81487 19.5318 1.16978 18.9936 0.705673C18.4553 0.241567 17.7658 -0.00944679 17.0551 1.38585e-05C16.0524 7.72735e-05 15.0908 0.398456 14.3818 1.10751L7.79181 7.69585C6.72956 7.41989 5.61275 7.4337 4.55764 7.73585C3.10602 8.14633 1.85185 9.068 1.02656 10.3308C0.20127 11.5935 -0.139448 13.1122 0.0672798 14.6065C0.274008 16.1008 1.01423 17.4699 2.15136 18.4612C3.28848 19.4525 4.74577 19.999 6.25431 20C6.47253 19.9998 6.69059 19.9884 6.90764 19.9658C8.14944 19.8306 9.32262 19.3279 10.2769 18.5219C11.2312 17.7159 11.9232 16.6433 12.2643 15.4417C12.5674 14.387 12.5809 13.2701 12.3035 12.2083L12.8451 11.6667C13.1332 11.3771 13.3039 10.9912 13.3243 10.5833ZM4.58348 16.6667C4.33625 16.6667 4.09458 16.5934 3.88901 16.456C3.68345 16.3187 3.52324 16.1234 3.42863 15.895C3.33402 15.6666 3.30926 15.4153 3.3575 15.1728C3.40573 14.9303 3.52478 14.7076 3.69959 14.5328C3.87441 14.358 4.09714 14.2389 4.33961 14.1907C4.58209 14.1425 4.83342 14.1672 5.06183 14.2618C5.29024 14.3564 5.48546 14.5167 5.62281 14.7222C5.76017 14.9278 5.83348 15.1695 5.83348 15.4167C5.83348 15.7482 5.70178 16.0661 5.46736 16.3006C5.23294 16.535 4.915 16.6667 4.58348 16.6667Z" fill="#00549E"/>
	</svg>

				<label for="committee-inner-page-search" className="hide">Filter Committees by Keyword</label>
				<input type="search"
				       value={ this.state.filter_keyword }
				       onChange={ this.handleSearch.bind( this ) }
				       className="form-control form-filter-keyword"
				       id="committee-inner-page-search"
				       placeholder="Filter by keyword" />

				</div>

				<button type="button" className="text-button text-button-black remove-filter-button" onClick={ this.clearFilters.bind( this ) } name="Clear all search filters">
					<i className="fa-regular fa-circle-xmark"></i>
						Clear All
					</button>
				</div>
				
				{this.props.myCommittees.length >= 1 && (
					<div className="filter-checkbox-container" key="committees-not-in" onClick={() => this.handleCommitteesNotInClick()}>
					<label className="custom-checkbox no-parent" htmlFor="committees-not-in">
						<input 
							type="checkbox" 
							id="committees-not-in" 
							className="" 
							name="select-subcategory" 
							checked={this.state.committeesNotIn}
						/>
							<span className="checkmark"></span>
						</label>
						<label htmlFor="committees-not-in">Committees I'm not in </label>
					</div>
				)}
			</div>

		);
	}

	getNoCommitteesBanner() {
		return (<div className="information-banner">
				<span className="glyphicon glyphicon-info-sign" />
				<p>No Committees Found.</p>
			</div>
		);
	}

	showDirectLinkedCommittee( ccode ) {
		let committee = findCommittee( this.props.committees, ccode );
		this.switchTab( 'All' );
		this.setFilterKeywordByValue( committee.title );
		this.props.committeeDirectLinkSwitchTab( true );
	}

	render() {
		this.shownCommittees = this.props.committees.filter(committee => {
			const isPublicOrMember = committee.isPublic === "1" || this.props.myCommittees.includes(committee.code);
			if (this.state.committeesNotIn) {
				return isPublicOrMember && !this.props.myCommittees.includes(committee.code);
			}
			return isPublicOrMember;
		});
		this.workingGroups = this.filterCommittees( this.shownCommittees.filter( committee => committee.type === 'Working Group' ) );
		this.distributionList = this.filterCommittees( this.shownCommittees.filter( committee => committee.type === 'Distribution List' ) );
		this.myCommitteesWithAttr = this.filterCommittees( this.shownCommittees.filter( committee => this.props.myCommittees.includes( committee.code ) ) );
		
		//checking if direct link for committee is set. If it is, filter by that committee.
		if ( this.directLinkCommitteeCode && !this.props.hasSwitchedForDirectLink ) {
			if ( this.props.committees.length > 0 ) {
				this.showDirectLinkedCommittee( this.directLinkCommitteeCode );
			}
		}

		let committees = this.getCommittees();
		let currentPage = (typeof this.props.pagination.committees === 'undefined'
		                  ) ? 1 : this.props.pagination.committees;
		let index = (currentPage === 1
		            ) ? 0 : ((currentPage - 1
		                     ) * this.committeesPerPage
		                    );

		let htmlCommittees = committees.slice( index, index + this.committeesPerPage );

		return (
			<div className="overview-container">
				<div className="tab-filter-container">
					<div className="container">	
						{ this.getTabs() }
						{ this.getFilterOptions() }
					</div>
				</div>
				<div className="committees-container container">
					{ htmlCommittees.length > 0
						? htmlCommittees
						: this.getNoCommitteesBanner() }
				</div>
				<Pagination pageName={ 'committees' } itemsPerPage={ 8 } itemsLength={ committees.length } />
			</div>
		);
	}

}

function mapStateToProps( { currentTabs, myCommittees, requestedCommittees, myCommitteeTab, meetings, committees, searchTerm, selectedPolicyGroup, pagination, hasSwitchedForDirectLink } ) {
	return {
		currentTabs,
		myCommittees,
		requestedCommittees,
		myCommitteeTab,
		meetings,
		committees,
		searchTerm,
		selectedPolicyGroup,
		pagination,
		hasSwitchedForDirectLink
	};
}

export default connect( mapStateToProps, {
	switchMainTabDispatch,
	unsetCommitteeTab,
	switchPage,
	committeeDirectLinkSwitchTab,
	policyGroupFilter
} )( CommitteesPage );